<!-- Hero Section -->
<section
  class="bg-[url('/assets/images/fraud.jpg')] bg-cover bg-top min-h-[30vh] flex flex-col justify-center items-center text-white relative px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="absolute inset-0 bg-black opacity-70 z-0"></div>
  <div
    class="container flex flex-col justify-center items-center text-center z-40"
  >
    <h1 class="text-3xl lg:text-5xl font-extrabold text-center mb-3">
      Fraud Awareness
    </h1>
    <div class="bg-red-600 h-1 w-20 mb-3"></div>
    <p class="text-white font-medium text-center text-lg lg:text-xl">
      Things you should know to avoid being the victim of a fraudulent
      transaction
    </p>
  </div>
</section>

<section class="py-12 md:py-16 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <!-- Alert Component -->
  <div class="container mx-auto">
    <div
      class="mb-12 border-red-600/50 bg-red-50 text-gray-900 p-4 rounded-lg border flex gap-3"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-red-600 flex-shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <div>
        <h5 class="text-gray-900 font-medium mb-1">Important Notice</h5>
        <p class="text-gray-700">
          We don't own, buy or sell vehicles listed on our site.
          OnlyUsedTesla.com is an online vehicle listing service that connects
          car buyers with sellers. We are not car dealers. The information for
          any and all vehicles listed on our site comes directly from the
          seller, not us.
        </p>
      </div>
    </div>

    <div class="grid gap-8 md:grid-cols-2">
      <!-- Card Component -->
      <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div class="p-6">
          <h3 class="text-lg font-semibold text-gray-900">
            Seller Information & Vehicle Verification
          </h3>
          <p class="text-gray-600 text-sm">
            What you need to know about listings
          </p>
          <div class="mt-4 space-y-4">
            <p>
              We don't verify the vehicle or Seller information provided on our
              site.
            </p>

            <p>
              OnlyUsedTesla.com doesn't verify the personal information of any
              seller or the information about any vehicle listed on our site. It
              is the buyer's sole responsibility to take the necessary steps to
              verify that the personal information of any seller and any
              information provided on the listed vehicle is accurate.
            </p>

            <p>
              If you receive an email stating or implying that we have verified
              information about a particular buyer, seller or listing,
              <a routerLink="/contact" class="text-red-600 hover:underline">
                report it to us
              </a>
              and to local law enforcement.
            </p>
          </div>
        </div>
      </div>

      <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div class="p-6">
          <h3 class="text-lg font-semibold text-gray-900">
            Email Communications
          </h3>
          <p class="text-gray-600 text-sm">
            Protecting yourself from scam emails
          </p>
          <div class="mt-4 space-y-4">
            <p>
              If you receive an email that implies OnlyUsedTesla.com is selling
              or buying a vehicle, please
              <a routerLink="/contact" class="text-red-600 hover:underline">
                report it to us
              </a>
              and to local law enforcement.
            </p>

            <p>
              We don't ask you for personal or financial information via email.
            </p>

            <p>
              OnlyUsedTesla.com will never send emails requesting your financial
              information unless you are in the process of purchasing an ad on
              our website. We will not take down your listing because you don't
              provide account information. If you receive an email that asks for
              the kinds of information listed above, don't respond. Instead,
              <a routerLink="/contact" class="text-red-600 hover:underline">
                report the email to us
              </a>
              and to local law enforcement.
            </p>
          </div>
        </div>
      </div>

      <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div class="p-6">
          <h3 class="text-lg font-semibold text-gray-900">
            Warehousing & Shipping Services
          </h3>
          <p class="text-gray-600 text-sm">Avoiding common scams</p>
          <div class="mt-4 space-y-4">
            <p>We don't offer authorized warehousing or shipping services.</p>

            <p>
              OnlyUsedTesla.com doesn't own a warehouse, and we don't ship cars.
              Any email that requests a deposit or payment for shipment of a car
              "stored in an OnlyUsedTesla.com warehouse" is a scam.
            </p>

            <!-- <p>
            If a seller recommends a bogus warehousing or shipping service,
            <a href="#" class="text-red-600 hover:underline">report the seller</a>
            to us and to local law enforcement.
          </p> -->
          </div>
        </div>
      </div>

      <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div class="p-6">
          <h3 class="text-lg font-semibold text-gray-900">
            Transactions Between Buyers and Sellers
          </h3>
          <p class="text-gray-600 text-sm">Our role in your transaction</p>
          <div class="mt-4 space-y-4">
            <p>
              We don't get involved in transactions between buyers and sellers.
            </p>

            <p>
              Once you have identified a car you wish to purchase you must
              contact the seller directly to engage in any negotiations and
              finalize a sale. We are not involved in the negotiation or sale
              process beyond the listing of the vehicle. Accordingly, you should
              not respond to any email that appears to come from
              OnlyUsedTesla.com (for example, by displaying our logo) and urges
              you to complete the sale or purchase of a car listed on our site.
            </p>

            <p>
              We also do not guarantee or endorse any transactions, and we don't
              have preferred or pre-approved buyers or sellers.
              OnlyUsedTesla.com will never encourage you to buy any particular
              vehicle listed on OnlyUsedTesla.com or to sell your vehicle to any
              particular buyer.
            </p>

            <p>
              If you receive such emails, please report them to us and to local
              law enforcement.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Resources Section -->
<section class="py-12 md:py-16 px-3 md:px-5 2xl:px-28 3xl:px-52 bg-gray-50">
  <div class="container mx-auto">
    <div class="container mx-auto">
      <h2 class="text-2xl md:text-3xl font-bold mb-8 text-gray-900">
        Additional Resources
      </h2>
      <p class="mb-8 text-gray-700">
        Please see below for other sources for you to review to avoid being the
        victim of a fraudulent transaction:
      </p>
      <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <!-- Resource Card -->
        <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
          <div class="p-6">
            <h3 class="text-gray-900 flex items-center gap-2 font-semibold">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="size-5"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-dasharray="64"
                  stroke-dashoffset="64"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 2l-9 3.5v6.5c0 3.5 3.5 9 8 10c4.5 -1 8 -6.5 8 -10v-6.5l-8 -3.5Z"
                >
                  <animate
                    fill="freeze"
                    attributeName="stroke-dashoffset"
                    dur="0.6s"
                    values="64;0"
                  />
                </path>
              </svg>
              Internet Crime Complaint Center (IC3)
            </h3>
            <div class="mt-4">
              <a
                href="https://www.ic3.gov"
                class="text-red-600 hover:underline flex items-center gap-1"
              >
                Internet Fraud Preventive Measures
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="size-5"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6v2H5v12h12v-6zM13 3v2h4.586l-7.793 7.793l1.414 1.414L19 6.414V11h2V3z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
          <div class="p-6">
            <h3 class="text-gray-900 flex items-center gap-2 font-semibold">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="size-5"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-dasharray="64"
                  stroke-dashoffset="64"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 2l-9 3.5v6.5c0 3.5 3.5 9 8 10c4.5 -1 8 -6.5 8 -10v-6.5l-8 -3.5Z"
                >
                  <animate
                    fill="freeze"
                    attributeName="stroke-dashoffset"
                    dur="0.6s"
                    values="64;0"
                  />
                </path>
              </svg>
              Better Business Bureau (BBB)
            </h3>
            <div class="mt-4 space-y-2">
              <a
                href="https://www.bbb.org/consumer-education"
                class="text-red-600 hover:underline flex items-center gap-1"
              >
                Be a Smarter Consumer
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="size-5"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6v2H5v12h12v-6zM13 3v2h4.586l-7.793 7.793l1.414 1.414L19 6.414V11h2V3z"
                  />
                </svg>
              </a>
              <a
                href="https://www.bbb.org/scamtracker"
                class="text-red-600 hover:underline flex items-center gap-1"
              >
                Top Scams
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="size-5"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6v2H5v12h12v-6zM13 3v2h4.586l-7.793 7.793l1.414 1.414L19 6.414V11h2V3z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
          <div class="p-6">
            <h3 class="text-gray-900 flex items-center gap-2 font-semibold">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="size-5"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-dasharray="64"
                  stroke-dashoffset="64"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 2l-9 3.5v6.5c0 3.5 3.5 9 8 10c4.5 -1 8 -6.5 8 -10v-6.5l-8 -3.5Z"
                >
                  <animate
                    fill="freeze"
                    attributeName="stroke-dashoffset"
                    dur="0.6s"
                    values="64;0"
                  />
                </path>
              </svg>
              Federal Trade Commission (FTC)
            </h3>
            <div class="mt-4">
              <a
                href="https://consumer.ftc.gov"
                class="text-red-600 hover:underline flex items-center gap-1"
              >
                Practical Tips to Help You Be on Guard Against Internet Fraud
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="size-5"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6v2H5v12h12v-6zM13 3v2h4.586l-7.793 7.793l1.414 1.414L19 6.414V11h2V3z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
          <div class="p-6">
            <h3 class="text-gray-900 flex items-center gap-2 font-semibold">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="size-5"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-dasharray="64"
                  stroke-dashoffset="64"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 2l-9 3.5v6.5c0 3.5 3.5 9 8 10c4.5 -1 8 -6.5 8 -10v-6.5l-8 -3.5Z"
                >
                  <animate
                    fill="freeze"
                    attributeName="stroke-dashoffset"
                    dur="0.6s"
                    values="64;0"
                  />
                </path>
              </svg>
              Securities & Exchange Commission (SEC)
            </h3>
            <div class="mt-4">
              <a
                href="https://www.sec.gov/investor/alerts"
                class="text-red-600 hover:underline flex items-center gap-1"
              >
                Latest Alerts and Scams from SEC.gov
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="size-5"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6v2H5v12h12v-6zM13 3v2h4.586l-7.793 7.793l1.414 1.414L19 6.414V11h2V3z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
          <div class="p-6">
            <h3 class="text-gray-900 flex items-center gap-2 font-semibold">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="size-5"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-dasharray="64"
                  stroke-dashoffset="64"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 2l-9 3.5v6.5c0 3.5 3.5 9 8 10c4.5 -1 8 -6.5 8 -10v-6.5l-8 -3.5Z"
                >
                  <animate
                    fill="freeze"
                    attributeName="stroke-dashoffset"
                    dur="0.6s"
                    values="64;0"
                  />
                </path>
              </svg>
              California Department of Corporations
            </h3>
            <div class="mt-4">
              <a
                href="https://dfpi.ca.gov/consumers"
                class="text-red-600 hover:underline flex items-center gap-1"
              >
                Top 10 Tips to Avoid Online Escrow Fraud
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="size-5"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6v2H5v12h12v-6zM13 3v2h4.586l-7.793 7.793l1.414 1.414L19 6.414V11h2V3z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Report Fraud Section -->
<section class="py-12 md:py-16 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div class="container mx-auto">
    <div class="max-w-3xl flex flex-col gap-y-6">
      <div>
        <h2 class="text-2xl md:text-3xl font-bold text-gray-900 mb-1.5">
          Report Suspected Fraud
        </h2>
        <p class="text-gray-700">
          If you believe you've encountered fraudulent activity related to a
          Tesla purchase or sale, please report it immediately.
        </p>
      </div>
      <div class="flex flex-col sm:flex-row gap-4 mt-">
        <a
          href="mailto:contact@onlyusedtesla.com?subject=Suspicious Activity Report&body=Describe the suspicious activity here..."
          class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-300 text-center"
        >
          Report Suspicious Activity
        </a>
        <button
          routerLink="/contact"
          class="px-4 py-2 border border-gray-300 text-gray-700 hover:text-gray-900 hover:bg-gray-100 hover:border-gray-400 rounded-lg transition-colors duration-300 cursor-pointer text-center"
        >
          Contact Support
        </button>
      </div>
    </div>
  </div>
</section>
